import React, { Suspense, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { LicenseInfo } from '@mui/x-license-pro';
import rootReducer from './redux/reducers-v2';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { configureStore } from '@reduxjs/toolkit';
import immutableStateInvariantMiddleware from 'redux-immutable-state-invariant';
import 'react-toastify/dist/ReactToastify.css';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

// Add scroll fix styles
const scrollFixStyles = `
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-y: auto !important;
    overflow-x: hidden;
  }
  
  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
`;

// Inject styles into document head
const styleEl = document.createElement('style');
styleEl.innerHTML = scrollFixStyles;
document.head.appendChild(styleEl);

LicenseInfo.setLicenseKey(
  '7620687c0b5ee435e466a78918e53ac6Tz05ODk4OCxFPTE3NTkwNzM5NzgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPVEzLTIwMjQsS1Y9Mg=='
);

const middlewares = [];

if (process.env.NODE_ENV !== 'production') {
  middlewares.push(immutableStateInvariantMiddleware());
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middlewares),
});

const root = createRoot(document.getElementById('root'));

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="align-c mt-5">
          <h1>Une erreur s'est produite. Veuillez réessayer.</h1>
          <p className="mt-1">Node - 2025 ©</p>
        </div>
      );
    }
    return this.props.children;
  }
}

root.render(
  <ErrorBoundary>
    <Suspense>
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <App />
        </LocalizationProvider>
      </Provider>
    </Suspense>
  </ErrorBoundary>
);
